import { ref } from 'vue'
import {useStore} from 'vuex'

export default {
    name: "PostHeader",
    props: {
        postId: {
            type: String,
            required: true
        },
        authorId: {
            type: String,
            required: true
        },
        canEdit: {
            type: Boolean,
            default: false
        },
        isFrivilligContext: {
            type: Boolean,
            default: false
        },
        authorId: {
            type: String,
            required: true
        },
        groupId: {
            type: String,
            required: true
        },
    },  
    setup(props){
        const store = useStore()

        const saveStatus =  ref(false)

        const startUserInfoOverlay = function(e){
            if(!props.authorId){
                return
            }

            const overlayContent = props.isFrivilligContext
                ? 'MemberOverlayProfileCard'
                : 'MemberOverlay'
            
            store.commit('main/set_page_overlay_content_data', {
                userId: props.authorId,
                isFrivilligContext: props.isFrivilligContext
            })

            store.dispatch('main/openPageOverlay',{
                overlayContent: overlayContent,
                returnTarget: e.currentTarget,
            })
        }

        const startDeleteOverlay = function(e) {
            store.commit('main/set_page_overlay_content_data', {
                callback: () => {
                    store.dispatch('forum/deletePost', {
                        id: props.postId
                    })
                }
            })

            store.dispatch('main/openPageOverlay',{
                overlayContent: 'DeletePostOverlay',
                returnTarget: e.currentTarget
            })
        }

        const handleLike = async function(e){
            let like = true
            if (e.target.classList.contains("kb-post-header__contents-bottom-right-button--filled")) { 
                like = false
            }
            const response = await store.dispatch('forum/submitLikePost', { like: like, id: props.postId })

            if (response.status === 'success') {
                e.target.classList.toggle("kb-post-header__contents-bottom-right-button--filled")
            }
        }

        const handleSave = async function(e){
            saveStatus.value = true

            if (e.target.classList.contains("kb-post-header__contents-bottom-right-button--filled")) {         
                saveStatus.value = false
            }
        
            e.target.setAttribute('aria-pressed',  saveStatus.value)
            
            const response = await store.dispatch('forum/submitSavePost', { save: saveStatus.value, id: props.postId })
            
            if (response.status === 'success') {
                e.target.classList.toggle("kb-post-header__contents-bottom-right-button--filled")
            }
        }

        const scrollToElement = (id) => {
            const target = document.getElementById(id)
            target?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
        }

        return {
            startUserInfoOverlay,
            startDeleteOverlay,
            handleLike,
            handleSave,
            scrollToElement,
            saveStatus
        }
    }
}